import { useCallback } from "react";

import { useTranslation } from "./useTranslation";
import { getErrorMessageKey } from "../lib/errorUtils";

/**
 * Generic error translation hook.
 * - Stays feature-agnostic by not hardcoding namespaces.
 * - Callers can pass feature namespaces to ensure preloading and avoid flicker.
 */
export function useErrorTranslation(namespaces?: string | string[]) {
  // Do not hardcode feature namespaces here; allow caller to opt-in
  const { t } = useTranslation(namespaces);

  const translateError = useCallback((error: unknown): string => {
    const { key, fallback } = getErrorMessageKey(error);
    
    try {
      const translatedMessage = t(key);
      
      // If the translation key wasn't found, i18next returns the key itself
      if (translatedMessage === key) {
        return fallback;
      }
      
      return translatedMessage;
    } catch {
      // Fallback to the raw message if translation fails
      return fallback;
    }
  }, [t]);

  return { translateError };
}
